"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const firmenich_grey_png_1 = tslib_1.__importDefault(require("../assets/img/firmenich-grey.png"));
const ipside_grey_png_1 = tslib_1.__importDefault(require("../assets/img/ipside-grey.png"));
const regimbeau_grey_png_1 = tslib_1.__importDefault(require("../assets/img/regimbeau-grey.png"));
const satt_axlr_grey_png_1 = tslib_1.__importDefault(require("../assets/img/satt_axlr-grey.png"));
const thales_grey_png_1 = tslib_1.__importDefault(require("../assets/img/thales-grey.png"));
const _hoisted_1 = { class: "arkyan-container clients-section" };
const _hoisted_2 = (0, vue_1.createStaticVNode)("<div class=\"arc-container\" id=\"arc-container\"><div class=\"arc arc-one\"></div><div class=\"arc arc-two\"></div><div class=\"arc arc-three\"></div><div class=\"arc arc-four\"></div><div class=\"arc arc-five\"></div><div class=\"arc arc-six\"></div></div>", 1);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "clients-container" };
const _hoisted_5 = { class: "clients-item" };
const _hoisted_6 = {
    class: "block-text",
    id: "block-text"
};
const _hoisted_7 = (0, vue_1.createStaticVNode)("<div class=\"slider\" id=\"slider\"><div class=\"slide-track\"><div class=\"slide\"><img src=\"" + firmenich_grey_png_1.default + "\" alt=\"logo-firmenich\"></div><div class=\"slide\"><img src=\"" + ipside_grey_png_1.default + "\" alt=\"logo-ipside\"></div><div class=\"slide\"><img src=\"" + regimbeau_grey_png_1.default + "\" alt=\"logo-regimbeau\"></div><div class=\"slide\"><img src=\"" + satt_axlr_grey_png_1.default + "\" alt=\"logo-satt_axlr\"></div><div class=\"slide\"><img src=\"" + thales_grey_png_1.default + "\" alt=\"logo-thales\"></div></div></div>", 1);
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("section", _hoisted_1, [
        _hoisted_2,
        (0, vue_1.createElementVNode)("div", _hoisted_3, [
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                (0, vue_1.createElementVNode)("div", _hoisted_5, [
                    (0, vue_1.createElementVNode)("div", _hoisted_6, [
                        (0, vue_1.createElementVNode)("h1", null, (0, vue_1.toDisplayString)(_ctx.$t('clients.firstSlideTitle')), 1),
                        (0, vue_1.createElementVNode)("h2", null, (0, vue_1.toDisplayString)(_ctx.$t('clients.firstSlideParagraph')), 1)
                    ])
                ]),
                _hoisted_7
            ])
        ])
    ]));
}
exports.render = render;
